import { render, staticRenderFns } from "./EventsCreate.vue?vue&type=template&id=46969b04&scoped=true"
import script from "./EventsCreate.vue?vue&type=script&lang=js"
export * from "./EventsCreate.vue?vue&type=script&lang=js"
import style0 from "./EventsCreate.vue?vue&type=style&index=0&id=46969b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46969b04",
  null
  
)

export default component.exports